import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import elementTypeIds from '@src/constants/element-types';

export const REVIEWER_NAME_SENTINEL = '__reviewer_name__';
const NONE_VALUE = '__none__';

// Element types that never produce useful text DATA responses — exclude from field mapping pickers
const NON_TEXT_ELEMENT_TYPE_IDS = new Set([
  elementTypeIds.VIDEO,
  elementTypeIds.IMAGE,
  elementTypeIds.CHECKBOX,
  elementTypeIds.SUBMISSION_TYPE_SELECTOR
]);

/**
 * Two dropdowns for choosing which campaign submission field becomes the
 * title and description of a video in a library or plugin.
 *
 * elements: [{ id: string, label: string }] — DATA-type campaign elements
 * titleElementId / descriptionElementId: current values (UUID, '__reviewer_name__', or null)
 * onChange: ({ titleElementId, descriptionElementId }) => void
 */
const VpFieldMappingInputs = ({
  elements = [],
  titleElementId = null,
  descriptionElementId = null,
  onChange
}) => {
  const textElements = elements.filter(
    (el) => !el.elementTypeId || !NON_TEXT_ELEMENT_TYPE_IDS.has(el.elementTypeId)
  );

  const options = [
    { value: NONE_VALUE, label: 'None (use default)' },
    ...textElements.map((el) => ({ value: el.id, label: el.label }))
  ];

  const toSelectValue = (id) => id || NONE_VALUE;
  const fromSelectValue = (v) => (v === NONE_VALUE ? null : v);

  const handleTitleChange = (e) => {
    onChange({ titleElementId: fromSelectValue(e.target.value), descriptionElementId });
  };

  const handleDescriptionChange = (e) => {
    onChange({ titleElementId, descriptionElementId: fromSelectValue(e.target.value) });
  };

  return (
    <Stack gap={2} sx={{ maxWidth: 360 }}>
      <FormControl size="small" fullWidth>
        <InputLabel>Title Field</InputLabel>
        <Select
          label="Title Field"
          value={toSelectValue(titleElementId)}
          onChange={handleTitleChange}
        >
          {options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl size="small" fullWidth>
        <InputLabel>Description Field</InputLabel>
        <Select
          label="Description Field"
          value={toSelectValue(descriptionElementId)}
          onChange={handleDescriptionChange}
        >
          {options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
};

VpFieldMappingInputs.propTypes = {
  elements: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, label: PropTypes.string })
  ),
  titleElementId: PropTypes.string,
  descriptionElementId: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default VpFieldMappingInputs;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/VpFieldMappingInputs/VpFieldMappingInputs.jsx